module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading": _vm.isLoading,
      "is-panel": ""
    }
  }, [
    [_c('div', {
      staticClass: "latest-activity"
    }, [(_vm.activities.length > 0 && !_vm.isError) ? _c('div', [_c('div', {
      staticClass: "widget-header"
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('ui.dashboard.latest_activity.label')))])]), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, _vm._l((_vm.activities), function(activity, index) {
      return _c('div', {
        key: index,
        staticClass: "activity-item"
      }, [_c('div', {
        staticClass: "icon"
      }, [(activity.activity === _vm.LEAD_CREATE) ? _c('img', {
        attrs: {
          "src": require("../../../../../assets/latest-activity-created.svg")
        }
      }) : (activity.activity === _vm.LEAD_UPDATE) ? _c('img', {
        attrs: {
          "src": require("../../../../../assets/latest-activity-list-update.svg")
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('router-link', {
        staticClass: "link",
        attrs: {
          "to": {
            name: 'project_lead_edit',
            params: {
              id: activity.project.identifier,
              lead_id: activity.lead.identifier
            }
          }
        }
      }, [(activity.person.name) ? _c('div', [_vm._v("\n                        " + _vm._s(activity.person.name) + "\n                      ")]) : _c('div', [_vm._v("\n                        " + _vm._s(_vm.$t('ui.dashboard.latest_activity.incomplete_lead')) + "\n                      ")])]), _vm._v(" "), (activity.activity === _vm.LEAD_CREATE) ? _c('p', {
        staticClass: "activity-description truncate-text link"
      }, [_vm._v("\n                      " + _vm._s(_vm.$t('ui.dashboard.latest_activity.added_to')) + " "), _c('router-link', {
        attrs: {
          "to": {
            name: 'project_leads',
            params: {
              id: activity.project.identifier
            }
          }
        }
      }, [_vm._v("\n                        " + _vm._s(activity.project.name) + "\n                      ")])], 1) : (activity.activity === _vm.LEAD_UPDATE) ? _c('p', {
        staticClass: "activity-description truncate-text link"
      }, [_vm._v("\n                      " + _vm._s(_vm.$t('ui.dashboard.latest_activity.edited_in')) + " "), _c('router-link', {
        attrs: {
          "to": {
            name: 'project_leads',
            params: {
              id: activity.project.identifier
            }
          }
        }
      }, [_vm._v("\n                        " + _vm._s(activity.project.name) + "\n                      ")])], 1) : _vm._e(), _vm._v(" "), (activity.by !== void 0) ? _c('p', {
        staticClass: "activity-details caption"
      }, [_vm._v("\n                      " + _vm._s(_vm.$t('ui.dashboard.latest_activity.by')) + " "), _c('span', [_vm._v(_vm._s(activity.by))]), _vm._v(" - " + _vm._s(_vm._f("date")(activity.at)) + "\n                    ")]) : _c('p', {
        staticClass: "activity-details caption"
      }, [_vm._v("\n                      " + _vm._s(_vm._f("date")(activity.at)) + "\n                    ")])], 1)])
    }), 0)]) : (_vm.activities.length === 0 && !_vm.isError) ? _c('div', {
      staticClass: "aligner"
    }, [_c('div', {
      staticClass: "text-center empty-state"
    }, [_c('img', {
      attrs: {
        "src": require("../../../../../assets/empty-default.svg")
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "empty-state-margin"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('ui.dashboard.activity_list_widget.empty_state_headline')) + "\n          ")]), _vm._v(" "), _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'project_new'
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('ui.dashboard.activity_list_widget.empty_state_intro')) + "\n          ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('div', {
      staticClass: "aligner"
    }, [_c('div', {
      staticClass: "text-center empty-state"
    }, [_c('img', {
      attrs: {
        "src": require("../../../../../assets/empty-default.svg")
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "empty-state-margin"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('ui.dashboard.widget_error')) + "\n          ")])])]) : _vm._e()])]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88529138","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/widgets/widgets/LatestActivityWidget.vue
// module id = 1961
// module chunks = 0